import React from 'react';
import RichTextEmbeddedAsset from "./RichTextEmbeddedAsset";

export default function RichTextLeaf(props) {
	// If we have marks, render it, remove from the array, and render another
	// rich text leaf until all the marks are gone.
	if (props.marks && props.marks.length) {
		let marks = props.marks.slice(0);
		const mark = marks.shift();

		switch (mark.type) {
			case 'bold':
				return <b><RichTextLeaf {...props} marks={marks} /></b>;
			case 'italic':
				return <i><RichTextLeaf {...props} marks={marks} /></i>;
			case 'underline':
				return (
					<span style={{textDecoration: 'underline'}}>
						<RichTextLeaf {...props} marks={marks} />
					</span>
				);
			default:
				// TODO - Add error handling / logging when attempting to render an unknown contentful "mark" type. (bold, italic, underline, etc.)
				return null;
		}
	}

	const renderValue = (value) => [' ', '  '].includes(value) ? <React.Fragment>&nbsp;</React.Fragment> : value;

	// If we have no marks, render the value itself
	switch (props.nodeType) {
		case 'text':
			// When rendering text, convert "\n" characters to html <br> tags
			let text = props.value.split("\n");
			return text.length === 1 ? renderValue(props.value) : (
				text.map((value, index) => (
					<React.Fragment key={index}>
						{renderValue(value)}
						{index < text.length - 1 && <br />}
					</React.Fragment>
				))
			);
		case 'embedded-entry-inline':
			return props.embeddedEntryResolver(props.data.target)
		case 'embedded-asset-block':
			return <RichTextEmbeddedAsset asset={props.data.target} />
		default:
			// TODO - Add error handling / logging when attempting to render a contentful leaf value of unknown type (text, embedded-entry-inline, etc.)
			return null;
	}
}
